import { useQuery } from 'react-query'
import request from 'superagent'
import { getApiServer } from '../../utils/domain'

export default function useMemberAccounts(): any {
  return useQuery('member-accounts', async () => {
    return await request.get(`${getApiServer()}/admin/member-accounts`).set('Accept', 'application/json').withCredentials().then((res) => res.body)
  }, {
    staleTime: Infinity,
    cacheTime: 5 * 60 * 1000,
    retry: 0
  })
}